export type TipoDocumento = 'CPF' | 'CNPJ';

export class SocioModel {
  constructor(
    public codKycSocio: number | null,
    public dscNome: string,
    public numCpfCnpj: string,
    public dscTipoPessoa: TipoDocumento,
    public datNascimento: string | null,
    public dscNomePai: string | null,
    public dscNomeMae: string | null,
    public dscNomeReduzido: string | null,
    public datFundacao: string | null,
  ) {}

  static fromJson(json: any): SocioModel {
    const doc = (json.numCpfCnpj || '').replace(/\D/g, '');
    const tipo: TipoDocumento = json.dscTipoPessoa || (doc.length > 11 ? 'CNPJ' : 'CPF');
    return new SocioModel(
      json.codKycSocio ?? null,
      json.dscNome || '',
      doc,
      tipo,
      json.datNascimento || null,
      json.dscNomePai || null,
      json.dscNomeMae || null,
      json.dscNomeReduzido || null,
      json.datFundacao || null,
    );
  }

  toJson(): any {
    return {
      codKycSocio: this.codKycSocio,
      dscNome: this.dscNome,
      numCpfCnpj: this.numCpfCnpj,
      dscTipoPessoa: this.dscTipoPessoa,
      datNascimento: this.datNascimento,
      dscNomePai: this.dscNomePai,
      dscNomeMae: this.dscNomeMae,
      dscNomeReduzido: this.dscNomeReduzido,
      datFundacao: this.datFundacao,
    };
  }
}
